import { API, graphqlOperation } from "aws-amplify";
import { configurePlusAppsync, configureGenericAppSync } from 'src/context/AuthContextUtility';

const safeParse = (val) => {
    let parsed = typeof val === 'string' ? JSON.parse(val) : val;
    return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
};

export const getDocumentTreeWithTracks = async (filters) => {
    await configurePlusAppsync();
    const qry = `query GetDocumentTreeWithTracks($filters: AWSJSON!) {
        getDocumentTreeWithTracks(filters: $filters)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { filters: JSON.stringify(filters) }));
    return safeParse(response.data.getDocumentTreeWithTracks);
};

export const updateDocumentTreeTrack = async (input) => {
    await configurePlusAppsync();
    const qry = `mutation UpdateDocumentTreeTrack($input: AWSJSON!) {
        updateDocumentTreeTrack(input: $input)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { input: JSON.stringify(input) }));
    return safeParse(response.data.updateDocumentTreeTrack);
};

export const updateDocumentTreeConfig = async (input) => {
    await configurePlusAppsync();
    const qry = `mutation UpdateDocumentTreeConfig($input: AWSJSON!) {
        updateDocumentTreeConfig(input: $input)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { input: JSON.stringify(input) }));
    return safeParse(response.data.updateDocumentTreeConfig);
};

export const addDocumentTreeBlock = async (input) => {
    await configurePlusAppsync();
    const qry = `mutation AddDocumentTreeBlock($input: AWSJSON!) {
        addDocumentTreeBlock(input: $input)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { input: JSON.stringify(input) }));
    return safeParse(response.data.addDocumentTreeBlock);
};

export const getDocumentFromStore = async (filters) => {
    await configurePlusAppsync();
    const qry = `query GetDocumentFromStore($filters: AWSJSON!) {
        getDocumentFromStore(filters: $filters)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { filters: JSON.stringify(filters) }));
    return safeParse(response.data.getDocumentFromStore);
};

export const getDocumentBlocks = async (filters) => {
    await configurePlusAppsync();
    const qry = `query GetDocumentBlocks($filters: AWSJSON!) {
        getDocumentBlocks(filters: $filters)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { filters: JSON.stringify(filters) }));
    return safeParse(response.data.getDocumentBlocks);
};

export const listAllServicesForApp = async (appId) => {
    await configurePlusAppsync();
    const qry = `query ListAllServicesForApp($app_id: String!) {
        listAllServicesForApp(app_id: $app_id)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { app_id: appId }));
    return safeParse(response.data.listAllServicesForApp);
};

export const deleteDocumentTreeBlock = async (input) => {
    await configurePlusAppsync();
    const qry = `mutation DeleteDocumentTreeBlock($input: AWSJSON!) {
        deleteDocumentTreeBlock(input: $input)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { input: JSON.stringify(input) }));
    return safeParse(response.data.deleteDocumentTreeBlock);
};

export const getDocumentTree = async (filters) => {
    await configurePlusAppsync();
    const qry = `query GetDocumentTree($filters: AWSJSON!) {
        getDocumentTree(filters: $filters)
    }`;
    const response = await API.graphql(graphqlOperation(qry, { filters: JSON.stringify(filters) }));
    return safeParse(response.data.getDocumentTree);
};
